module.exports = __webpack_public_path__ + "static/img/cuelist-full.311ed85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cuelist-full.svg
// module id = 200
// module chunks = 21